import { useEffect, useRef, useState } from 'react';
import { getFetch } from '../../../../fetch/fetch';
import { reorderTaskBySyncApi } from './components/function';

// TODO 프로젝트 트리 로드 + 낙관적 갱신(맨 위로 이동, 댓글 추가) 공용 훅.
// 본사직원페이지(main.tsx)와 홈 화면 TODO 탭(home.tsx)이 같이 씀.
// - user: 로그인 사용자 (없으면 fetch 안 함)
// - enabled: false 면 fetch 안 함 (학생 홈 등 불필요한 조회 방지)
// - category: "headquarters" | "facility"
// - externalUpdate: 소켓 newTodoistData 등 외부 갱신 트리거 값
const useTodoProjects = (options: { user: any, enabled?: boolean, category?: string, externalUpdate?: any }) => {

    const { user, category = "headquarters" } = options;
    const enabled = options.enabled !== undefined ? options.enabled : true;
    const externalUpdate = options.externalUpdate;

    const [projects, setProjects] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [update, setUpdate] = useState<number>(0);

    //연달아 재조회할 때 앞선 요청의 응답이 늦게 도착해 최신 데이터를 덮어쓰지 않도록 마지막 요청만 반영
    const todoistRequestSeqRef = useRef(0);

    useEffect(() => {

        if (!user) return;
        if (!enabled) return;

        getTodoistData();

    }, [user, enabled, update, externalUpdate]);

    const getTodoistData = async () => {

        const seq = ++todoistRequestSeqRef.current;

        try {

            const url = category === "facility"
                ? "/dashboard/todoist/todoistData?category=facility"
                : "/dashboard/todoist/todoistData";

            const result: any = await getFetch(url);

            if (seq !== todoistRequestSeqRef.current) return;

            setProjects([...result.data]);
            setLoading(false);

        } catch (e) {
            console.log(e);
        }

    }

    const letsUpdate = () => {
        setUpdate(Math.random());
    }

    const moveTaskToTop = async (taskId: number) => {

        const newProjects = [...projects];

        const items: any = [];

        newProjects.forEach((project: any) => {

            project.sections.forEach((section: any) => {

                const task = section.tasks.find((task: any) => task.id === taskId);

                if (!task) return;

                const currentIndex = section.tasks.indexOf(task);

                if (currentIndex === 0) return;

                section.tasks.splice(currentIndex, 1);
                section.tasks.unshift(task);

                section.tasks.forEach((task: any, index: number) => {

                    const child_order = index + 1;

                    const oneRow: any = {};

                    oneRow.id = task.v2_id;
                    oneRow.child_order = child_order;

                    items.push(oneRow);

                })

            });

        });

        setProjects([...newProjects]);

        try {

            if (!user) return;

            await reorderTaskBySyncApi("item_reorder", items);

        } catch (e) {
            console.log(e);
        }

    }

    const addNoteToTask = async (projectV2Id: string, sectionV2Id: string | undefined, taskV2Id: string, note: any) => {

        const NewProjects = [...projects];

        NewProjects.forEach((project: any) => {
            if (project.v2_id !== projectV2Id) return;

            project.sections.forEach((section: any) => {

                if (sectionV2Id && section.v2_id !== sectionV2Id) return;

                section.tasks.forEach((task: any) => {

                    if (task.v2_id === taskV2Id) {
                        if (task.notes) {
                            task.notes.push(note);
                            return;
                        }
                    }

                    if (!task.subTasks) return;

                    task.subTasks.forEach((subTask: any) => {
                        if (subTask.v2_id === taskV2Id) {
                            if (subTask.notes) {
                                subTask.notes.push(note);
                                return;
                            }
                        }

                        if (!subTask.subTasks) return;

                        subTask.subTasks.forEach((subSubTask: any) => {
                            if (subSubTask.v2_id === taskV2Id) {
                                if (subSubTask.notes) {
                                    subSubTask.notes.push(note);
                                    return;
                                }
                            }
                        })
                    })

                })

            })

        })

        setProjects([...NewProjects]);

    }

    //댓글 읽음: 해당 task 의 모든 댓글 readUser 에 본인 추가 (drawer 재열람 시 즉시 반영용)
    const markNotesRead = (projectV2Id: string, sectionV2Id: string | undefined, taskV2Id: string, userId: number, userName: string) => {

        const apply = (task: any) => {
            if (task.v2_id !== taskV2Id || !Array.isArray(task.notes)) return;
            task.notes = task.notes.map((note: any) => {
                const readUser: any[] = Array.isArray(note.readUser) ? note.readUser : [];
                if (readUser.some((id: any) => `${id}` === `${userId}`)) return note;
                const readUserName: string[] = Array.isArray(note.readUserName) ? [...note.readUserName, userName] : [userName];
                return { ...note, readUser: [...readUser, userId], readUserName, readUserNameText: readUserName.join(" / ") };
            });
        };

        const NewProjects = [...projects];

        NewProjects.forEach((project: any) => {
            if (project.v2_id !== projectV2Id) return;
            project.sections.forEach((section: any) => {
                if (sectionV2Id && section.v2_id !== sectionV2Id) return;
                section.tasks.forEach((task: any) => {
                    apply(task);
                    (task.subTasks || []).forEach((subTask: any) => {
                        apply(subTask);
                        (subTask.subTasks || []).forEach((subSubTask: any) => apply(subSubTask));
                    });
                });
            });
        });

        setProjects([...NewProjects]);

    }

    return { projects, loading, letsUpdate, moveTaskToTop, addNoteToTask, markNotesRead };

}

export default useTodoProjects;
